export const recruitSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://www.datauniverse.co.kr/#website',
      url: 'https://www.datauniverse.co.kr',
      name: '㈜데이터유니버스',
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.datauniverse.co.kr/recruit/#webpage',
      url: 'https://www.datauniverse.co.kr/recruit',
      name: '채용 | ㈜데이터유니버스',
      description: '㈜데이터유니버스의 채용 정보 및 현재 채용 중인 포지션을 안내합니다.',
      isPartOf: {
        '@id': 'https://www.datauniverse.co.kr/#website',
      },
    },
    {
      '@type': 'Organization',
      '@id': 'https://www.datauniverse.co.kr/#organization',
      name: '㈜데이터유니버스',
      legalName: '㈜데이터유니버스',
      url: 'https://www.datauniverse.co.kr',
      logo: 'https://img.datau.co.kr/dulogo.png',
      sameAs: 'https://www.datauniverse.co.kr',
    },
    {
      '@type': 'JobPosting',
      title: '㈜데이터유니버스 채용 안내',
      url: 'https://www.datauniverse.co.kr/recruit',
      hiringOrganization: {
        '@id': 'https://www.datauniverse.co.kr/#organization',
      },
    },
  ],
}
